import { useEffect, useState, Fragment } from "react";
import CustomTable from "../../../../components/CustomTable";
import { getVoucherByRedemptionUserId } from "../../../Vouchers/APIs/voucherApi";
import { parseFirebaseDateTime } from "../../../../utils/helper";

const UserVouchers = ({ user_id }) => {
  const [vouchers, setVouchers] = useState([]);
  const [loading, setLoading] = useState(false);

  const columns = [
    {
      title: "Code",
      dataIndex: "voucher_code",
      columnSearch: true,
    },
    {
      title: "Vendor",
      dataIndex: "vendor",
      columnSearch: true,
    },
    {
      title: "Package Price",
      dataIndex: "package_price_name",
      columnSearch: true,
    },

    {
      title: "Redemption Email",
      dataIndex: "redemption_email",
      render: (text) => {
        return text ? text : "-";
      },
    },
    {
      title: "Redemption At",
      dataIndex: "redemption_at",
      render: (redemption_at) =>
        redemption_at ? parseFirebaseDateTime(redemption_at) : "-",
    },
  ];

  const getVouchers = async (user_id) => {
    try {
      setLoading(true);
      let response = await getVoucherByRedemptionUserId(user_id);
      setVouchers(response);
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (user_id) getVouchers(user_id);
  }, [user_id]);

  return (
    <Fragment>
      <CustomTable dataSource={vouchers} columns={columns} loading={loading} />
    </Fragment>
  );
};

export default UserVouchers;
